<template>
  <b-row class="grab">
    <b-col class="col-main-pad">
      <b-row>
        <b-col lg="12" class="col-head-activity">
          <font-awesome-icon icon="crop-alt" />&nbsp; Configurar Sopa de Letras
        </b-col>
        <b-col lg="12">
          <b-form-group>
            <label for="name">Instrucciones de la Actividad</label>
            <b-form-textarea
              v-model="instrucciones"
              placeholder="Ingrese las Instrucciones para Realizar la Actividad"
              rows="2"
              max-rows="3"
            ></b-form-textarea>
          </b-form-group>
        </b-col>

        <b-col lg="12">
          <b-form-group>
            <label for="name">Tamaño de la cuadrícula</label>
            <b-form-select
              v-model="sizeValue"
              id="cuadriculaSize"
              class="border-visible"
              :options="cuadriculaSize"
              variant="primary"
            >
              <template slot="first">
                <option :value="null" disabled>Seleccione una opción</option>
              </template>
            </b-form-select>
          </b-form-group>
        </b-col>
        <b-col lg="12">
          <b-form-group>
            <vue-tags-input
              v-model="word"
              :tags="palabrasSelected"
              :placeholder="placeholderWords"
              @tags-changed="newWord => palabrasSelected = newWord"
              class="text-uppercase"
            />
          </b-form-group>
        </b-col>
      </b-row>
    </b-col>
    <!-- componente de botón de opciones del elemento  -->
    <options-element :index-element="idElement" :index-column="idColumn"></options-element>
  </b-row>
</template>

<script>
import VueTagsInput from "@johmun/vue-tags-input";
import OptionsElement from "./OptionsElement";

export default {
  name: "Sopa",
  components: { OptionsElement, VueTagsInput },
  props: {
    palabras: {
      type: Array,
      default: () => {
        return new Array();
      }
    },
    size: { type: Number, default: null },
    desc: { type: String },
    idElement: { type: Number },
    idColumn: { type: Number, default: null }
  },
  data() {
    return {
      instrucciones: this.desc,
      palabrasSelected: this.palabras,
      sizeValue: this.size,
      cuadriculaSize: [
        { value: 15, text: "Tamaño 15 x 15" },
        { value: 16, text: "Tamaño 16 x 16" },
        { value: 17, text: "Tamaño 17 x 17" },
        { value: 18, text: "Tamaño 18 x 18" },
        { value: 19, text: "Tamaño 19 x 19" },
        { value: 20, text: "Tamaño 20 x 20" },
        { value: 21, text: "Tamaño 21 x 21" },
        { value: 22, text: "Tamaño 22 x 22" },
        { value: 23, text: "Tamaño 23 x 23" },
        { value: 24, text: "Tamaño 24 x 24" },
        { value: 25, text: "Tamaño 25 x 25" }
      ],
      placeholderWords:
        "Ingresa la palabra y agregala dando enter, evita utilizar espacios",
      word: ""
    };
  },
  methods: {
    test() {
      console.log(this.sizeValue);
    }
  },
  watch: {
    palabrasSelected: {
      handler: function(change) {
        this.$store.dispatch("constructor/updateContentElement", {
          indexElement: this.idElement,
          data: change,
          field: "palabras",
          indexColumns: this.idColumn
        });
      },
      deep: true
    },
    instrucciones: function(change) {
      this.$store.dispatch("constructor/updateContentElement", {
        indexElement: this.idElement,
        data: change,
        field: "instrucciones",
        indexColumns: this.idColumn
      });
    },
    sizeValue: function(change) {
      this.$store.dispatch("constructor/updateContentElement", {
        indexElement: this.idElement,
        data: change,
        field: "size",
        indexColumns: this.idColumn
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.ti-new-tag-input-wrapper {
  text-transform: uppercase !important;
}
</style>